module.exports = __webpack_public_path__ + "static/ring_of_free_action-11cd70121ab88d0a48631e1cc9a4ff50.jpeg";